import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./theme.css";
import { App } from "./App.tsx";

const racine = document.getElementById("racine");
if (!racine) throw new Error("élément racine introuvable");
createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
